/**
 * 💳 PAYMENT CANCEL PAGE
 * Page affichée quand l'utilisateur annule le paiement
 * Détecte le domaine pour rediriger vers la bonne app
 */

import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  
  // Détecter si on est sur Heartbeats.fr
  const hostname = window.location.hostname;
  const isHeartbeatsDomain = hostname === 'heartbeats.fr' || hostname === 'www.heartbeats.fr';
  
  // Rediriger vers la bonne page selon le domaine
  const handleGoBack = () => {
    if (isHeartbeatsDomain) {
      navigate('/heartbeats-portal');
    } else {
      navigate('/client');
    }
  };

  return (
    <div className="min-h-screen overflow-x-hidden overflow-y-auto bg-gradient-to-b from-[#030014] via-[#0F0529] to-[#030014] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white/5 backdrop-blur-xl rounded-3xl p-8 text-center border border-white/10"
      >
        {/* Cancel Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', delay: 0.1 }}
          className="w-24 h-24 mx-auto bg-orange-500/20 rounded-full flex items-center justify-center mb-6"
        >
          <XCircle className="w-14 h-14 text-orange-400" />
        </motion.div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-white mb-2">
          Paiement annulé
        </h1>
        <p className="text-white/60 mb-8">
          Vous avez annulé le processus de paiement. Aucun montant n'a été débité.
        </p>

        {/* Buttons */}
        <div className="space-y-3">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate(-1)}
            className="w-full py-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl font-semibold text-white flex items-center justify-center gap-2"
          >
            <RefreshCw className="w-5 h-5" />
            Réessayer
          </motion.button>
          
          <button
            onClick={handleGoBack}
            className="w-full py-4 bg-white/10 hover:bg-white/20 rounded-xl font-semibold text-white transition-colors flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-5 h-5" />
            Retour à l'accueil
          </button>
        </div>

        {/* Help text - Email selon le domaine */}
        <p className="text-white/40 text-sm mt-6">
          Un problème ? Contactez-nous à{' '}
          <a 
            href={isHeartbeatsDomain ? "mailto:contact@heartbeats.fr" : "mailto:contact@la-petite-epicerie.shop"} 
            className="text-purple-400 hover:underline"
          >
            {isHeartbeatsDomain ? "contact@heartbeats.fr" : "contact@la-petite-epicerie.shop"}
          </a>
        </p>
      </motion.div>
    </div>
  );
};

export default PaymentCancelPage;
